<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="card">
      <div class="card-header">
        <h1>Create Post</h1>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <label for="Content">Content</label>
            <span class="error" v-if="!content && isFieldRequired">* field required</span>
            <div>
              <div class="position-relative">
                <textarea class="form-control" rows="3" placeholder="Content" v-model="content"></textarea>
                <emoji-picker @emoji="appendContent" :search="search">
                  <div
                    class="emoji-invoker"
                    slot="emoji-invoker"
                    slot-scope="{ events: { click: clickEvent } }"
                    @click.stop="clickEvent"
                  >
                    <svg
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                      />
                    </svg>
                  </div>
                  <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                    <div
                      class="emoji-picker"
                      :style="{ top:  '50px', left: screenWidth - 600 + 'px' }"
                    >
                      <div class="emoji-picker__search">
                        <input type="text" v-model="search" v-focus />
                      </div>
                      <div>
                        <div v-for="(emojiGroup, category) in emojis" :key="category">
                          <h5>{{ category }}</h5>
                          <div class="emojis">
                            <span
                              v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click="insert(emoji)"
                              :title="emojiName"
                            >{{ emoji }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </emoji-picker>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-4">
            <label for="Streamer">Streamer</label>
            <span class="error" v-if="!streamer && isFieldRequired">* field required</span>
            <v-select v-model="streamer" :options="streamersName"></v-select>
          </div>
          <div class="col-md-6 mt-4" v-if="selectedPhoto">
            <img :src="selectedPhoto" class="img-thumbnail" alt />
          </div>
          <div class="col-md-6 mt-4" v-if="selectedVideo">
            <a :href="selectedVideo.url" target="_blank" class="video">
              <span></span>
              <img :src="selectedVideo.thumbnail" class="img-thumbnail" alt />
            </a>
          </div>
          <div class="col-md-12 mt-4" v-if="selectedVideoAsFile">
            <h4>{{ selectedVideoAsFile.name }}</h4>
            <base-progress
              class="mt-4"
              v-if="uploadingVideo && uploadPercentage < 100"
              type="primary"
              :height="8"
              :value="uploadPercentage"
              label="Uploading . . ."
            ></base-progress>
          </div>
          <div class="col-md-12 mt-4 d-inline" v-if="!isLoading">
            <div class="text-center" id="file-input">
              <label>
                <input type="file" accept="video/mp4" @change="onFileChanged" />
                <span class="btn btn-sm btn-outline-primary">Choose Video</span>
              </label>
            </div>

            <div class="text-center" id="file-input">
              <label>
                <input type="file" accept="image/*" @change="onPhotoChanged" />
                <span class="btn btn-sm btn-outline-primary">Choose Photo</span>
              </label>
            </div>
          </div>
          <div class="col-md-12 text-center mt-6">
            <base-button :loading="isLoading" type="primary" @click="onCreateClicked()">Post</base-button>
          </div>
          <div class="col-md-12 text-center mt-5 mb-4" v-if="error">
            <span class="response-error">* {{ error.message }}</span>
          </div>
          <!-- <div class="col-md-12">
            <modal :show.sync="showUploadVideoModal" modalClasses="modal-lg">
              <div class="row">
                <div class="col-md-12">
                  <div class="video-modal-header text-center">
                    <div class="text-center w-100 pl-2 pr-2" id="file-input">
                      <label v-if="!uploadingVideo">
                        <input type="file" accept="video/mp4" @change="onFileChanged" />
                        <span class="btn btn-sm btn-upload">Upload a Video</span>
                      </label>
                      <base-progress
                        v-if="uploadingVideo && uploadPercentage < 100"
                        type="primary"
                        :height="8"
                        :value="uploadPercentage"
                        label="Uploading . . ."
                      ></base-progress>
                      <div
                        v-if="uploadPercentage === 100"
                        class="spinner-border text-primary"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mt-4">
                  <div class="row">
                    <div class="col-md-4 mb-4" v-for="video in videos" :key="video.url">
                      <div class="video">
                        <img
                          :src="video.thumbnail ?  video.thumbnail : require('@/assets/default_live_stream_thumbnail.jpg')"
                          class="img-thumbnail"
                          alt
                          @click="onVideoSelected(video)"
                        />
                        <p
                          v-if="selectedVideoUrl === video.url && selectedVideoStatus === 'in_progress'"
                          class="mt-3 text-center mb-0 text-warning"
                        >Video is under review</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <template slot="footer">
                <div class="col-md-12" align="right">
                  <base-button outline type="primary" class="btn-cancel" @click="closeModal">Cancel</base-button>
                </div>
              </template>
            </modal>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import {
  GET_VIDEOS,
  UPLOAD_VIDEO,
  GET_VIDEO_STATUS,
  GET_ALL_STREAMERS,
  CREATE_POST,
  UPLOAD_POST_PHOTO
} from '@/store/actions.type'

import VideoUploadModal from './VideoUploadModal'
import vSelect from 'vue-select'
import EmojiPicker from 'vue-emoji-picker'

export default {
  components: {
    VideoUploadModal,
    vSelect,
    EmojiPicker
  },
  data() {
    return {
      content: '',
      showUploadVideoModal: false,
      streamer: '',
      selectedVideo: '',
      selectedPhoto: '',
      selectedVideoAsFile: null,
      selectedPhotoAsFile: null,
      isFieldRequired: false,
      search: '',
      screenWidth: 0
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.$store.dispatch(GET_ALL_STREAMERS)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth
    },
    onChooseVideoClicked(e) {
      this.showUploadVideoModal = true
      this.$store.dispatch(GET_VIDEOS)
    },
    onFileChanged(e) {
      this.selectedPhoto = null
      this.selectedPhotoAsFile = null
      this.$store.state.newsfeed.error = null
      const file = e.target.files[0]
      e.target.value = ''
      this.selectedVideoAsFile = file
      // this.$store.dispatch(UPLOAD_VIDEO, file).then(res => {
      //   this.$store.dispatch(GET_VIDEOS)
      // })
    },
    onPhotoChanged(e) {
      this.selectedVideoAsFile = null
      this.$store.state.newsfeed.error = null
      const file = e.target.files[0]
      e.target.value = ''
      this.selectedPhotoAsFile = file
      const reader = new FileReader()
      reader.onload = event => {
        this.selectedPhoto = event.target.result
      }
      reader.readAsDataURL(file)
    },
    closeModal(e) {
      this.showUploadVideoModal = false
    },
    onVideoSelected(video) {
      if (video.status === 'complete') {
        this.selectedPhoto = ''
        this.selectedPhotoAsFile = null
        this.$store.state.newsfeed.error = null
        this.showUploadVideoModal = false
        this.selectedVideo = video
      } else {
        this.$store.dispatch(GET_VIDEO_STATUS, video.url)
      }
    },
    onCreateClicked() {
      if (this.content && this.streamer) {
        if (!this.selectedVideoAsFile && !this.selectedPhoto) {
          this.$store.state.newsfeed.error = {
            message: 'Please choose a video or a photo'
          }
          this.isFieldRequired = true
        } else {
          let streamer = this.streamers.filter(
            streamer => streamer.name === this.streamer
          )[0]
          if (this.selectedVideoAsFile) {
            this.$store
              .dispatch(UPLOAD_VIDEO, this.selectedVideoAsFile)
              .then(res => {
                this.createPost({
                  content: this.content,
                  image: '',
                  video: res.url,
                  userId: streamer.user.id
                })
              })
          } else if (this.selectedPhoto) {
            this.$store
              .dispatch(UPLOAD_POST_PHOTO, this.selectedPhotoAsFile)
              .then(url => {
                this.createPost({
                  content: this.content,
                  image: url,
                  video: '',
                  userId: streamer.user.id
                })
              })
          }
        }
      } else {
        this.isFieldRequired = true
      }
    },
    createPost(post) {
      this.$store
        .dispatch(CREATE_POST, {
          content: post.content,
          image: post.image,
          video: post.video,
          userId: post.userId
        })
        .then(() => {
          this.$router.push({ name: 'newsfeed' })
        })
    },
    appendContent(emoji) {
      this.content += emoji
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
  computed: {
    ...mapState({
      uploadingVideo: state => state.newsfeed.uploadingVideo,
      uploadPercentage: state => state.newsfeed.uploadPercentage,
      videos: state => state.newsfeed.videos,
      selectedVideoUrl: state => state.newsfeed.selectedVideoUrl,
      selectedVideoStatus: state => state.newsfeed.selectedVideoStatus,
      streamers: state => state.newsfeed.streamers,
      isLoading: state => state.newsfeed.isLoading,
      error: state => state.newsfeed.error
    }),
    ...mapGetters(['streamersName'])
  }
}
</script>
<style scoped>
.video-modal-header {
  /* min-height: 211px; */
  padding-top: 5rem;
  padding-bottom: 5rem;
  border-style: dashed;
  border-width: 1px;
  border-radius: 5px;
}
.btn-upload {
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  color: rgb(66, 82, 110) !important;
  border-width: 0px;
  text-decoration: none;
  background: rgba(9, 30, 66, 0.04);
  border-radius: 5px;
  padding: 0px 8px;
  transition: background 0.1s ease-out 0s,
    box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  outline: none !important;
  padding: 15px 20px;
}

.btn-upload:hover,
.btn-upload:focus,
.btn-upload:active {
  box-shadow: none !important;
}

.video {
  cursor: pointer;
  transition: 1s;
}
.video:hover {
  transform: scale(1.1, 1.1);
}

.card-header hr {
  border-top: 1px solid rgba(225, 225, 225, 0.5) !important;
  margin-top: 0 !important;
}

a.video {
  float: left;
  position: relative;
}
a.video span {
  width: 100%;
  height: 100%;
  position: absolute;
  background: url('http://www.slatecube.com/images/play-btn.png') no-repeat;
  background-position: 50% 50%;
  background-size: 15%;
}
.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}
</style>
